/**
 * Network Status Service
 * 
 * A centralized service for network status detection.
 * This service provides consistent methods for checking connection status.
 * (Refactored to online-only version)
 */

const networkStatus = {
  /**
   * Check if the device is currently offline
   * @returns {boolean} True if offline, false if online
   */
  isOffline: () => {
    return !navigator.onLine;
  },

  /**
   * In the online-only version, we always want to use online mode
   * This method is maintained for API compatibility with existing code
   * 
   * @returns {Promise<boolean>} Always returns false (online mode)
   */
  async shouldUseOfflineMode() {
    const isActuallyOffline = this.isOffline();
    
    if (isActuallyOffline) {
      console.log('Network status: Device is offline, but app is in online-only mode');
    }
    
    // Always return false - we're in online-only mode
    return false;
  },

  /**
   * Add event listeners for connection status changes
   * 
   * @param {Function} callback Function to call when connection status changes
   *                            Receives a boolean parameter (true if offline)
   */
  addConnectionStatusListener(callback) {
    if (typeof callback !== 'function') {
      console.error('addConnectionStatusListener requires a function callback');
      return;
    }
    
    window.addEventListener('online', () => {
      console.log('Network status: Device is now online');
      callback(false);
    });
    
    window.addEventListener('offline', () => {
      console.log('Network status: Device is now offline');
      callback(true);
    });
    
    // Return a function to remove the listeners
    return () => {
      window.removeEventListener('online', callback);
      window.removeEventListener('offline', callback);
    };
  }
};

export default networkStatus;
